import dayjs from 'dayjs'
import { GeckoInspection } from 'types'

export const INSPECTION_DATE_FORMAT = 'MMM D, YYYY'

export const getInspectionDate = (inspection: GeckoInspection): Date => {
  const dateOnEntry = dayjs(inspection.data.date)

  // The inspection loading in Forecast has a quirk as of (10/23/25) where if the date format is invalid, it will be set to a date object based on the current timestamp
  // This is undesirable - so if this is the case, we use the creation date instead
  if (dateOnEntry?.date() === dayjs().date()) {
    return dayjs(inspection.created_at).toDate()
  }

  return dateOnEntry.toDate()
}
